import PropTypes from 'prop-types';
import { Box, Dialog, IconButton } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

export default function ImagePreviewDialog({ imageUrl, open, onClose, title }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          position: 'relative',
          bgcolor: 'grey.900',
          boxShadow: 24,
          overflow: 'hidden',
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          zIndex: 2,
          color: 'common.white',
          bgcolor: 'rgba(0,0,0,0.4)',
          '&:hover': {
            bgcolor: 'rgba(0,0,0,0.56)',
          },
        }}
      >
        <GridCloseIcon />
      </IconButton>

      <Box
        component="img"
        src={imageUrl}
        alt={title}
        sx={{
          display: 'block',
          maxWidth: '100%',
          maxHeight: '80vh',
          objectFit: 'contain',
          bgcolor: 'grey.900',
        }}
      />
    </Dialog>
  );
}

ImagePreviewDialog.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
